/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2026 (original work) Open Assessment Technologies SA
 */

import {
    init,
    isLocalizedFormatsEnabled,
    resolveDisplayFormat,
    resetDateFormatConfig
} from '@oat-sa-private/ui-core';

resetDateFormatConfig();

// Capture factory default before tenant config is applied at runtime.
const LEGACY_DATETIME_DISPLAY_FORMAT = resolveDisplayFormat({ hasHour: true });

/**
 * Returns the ui-core legacy datetime pattern used when no tenant format config is active.
 * @returns {string}
 */
export function getLegacyDisplayFormat() {
    return LEGACY_DATETIME_DISPLAY_FORMAT;
}

export { init, isLocalizedFormatsEnabled, resolveDisplayFormat };
